@if (!backgroundsArray) {
    <div class="container" [ngClass]="{'dialog-background': sopoDialogRef}">
        <ng-container *ngIf="(myBackgrounds$ | async) && (activeBackground$ | async); else loading">
            <div
                class="background-items"
                *ngFor="let item of (myBackgrounds$ | async); trackBy: trackBackgrounds"
                (click)="onSelect(item)"
                [ngStyle]="{'background': getBackground(item)}"
                [ngClass]="{'item-border' : (activeBackground$ | async).id == item.id}"
            >
            </div>
        </ng-container>
    </div>

    <ng-template #loading>
        <sopo-loader-dots [type]="'two'"></sopo-loader-dots>
    </ng-template>
} @else {
    <swiper
        background_swiper
        [config]="sliderOptions"
        class="swiper"
        #backgroundSlide
    >
        <ng-template
            swiperSlide
            *ngFor="let item of (myBackgrounds$ | async); trackBy: trackBackgrounds"
        >
            <div
                class="wrapper"
                (click)="onSelect(item)"
            >
                <div
                    class="background-items-swiper"
                    [ngStyle]="{'background': getBackground(item)}"
                    [ngClass]="{'item-border' : (activeBackground$ | async)?.id == item.id}"
                >
                </div>
                <label class="name-tag">
                    {{ item.name.length > 10 ? (item.name | slice:0:10) : item.name }}
                </label>
            </div>
        </ng-template>
    </swiper>
}
